import { IObservationPayload, IObservationResponse } from './sharedTypes'
import type { CamelCasedPropertiesDeep } from 'type-fest'

export type CreateObservation = (
  payload: IObservationPayload
) => Promise<CamelCasedPropertiesDeep<IObservationResponse>>
